var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "店铺默认配置（只支持网店）",
        visible: _vm.innerVisible,
        width: "640px",
      },
      on: {
        "update:visible": function ($event) {
          _vm.innerVisible = $event
        },
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "formRef",
          attrs: {
            model: _vm.form,
            rules: _vm.rules,
            "label-width": "120px",
            size: "small",
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "店铺所在地区", prop: "region" } },
            [
              _c("el-cascader", {
                staticStyle: { width: "100%" },
                attrs: {
                  options: _vm.regionOptionsProp,
                  props: {
                    checkStrictly: false,
                    value: "id",
                    label: "name",
                    children: "child",
                    emitPath: true,
                  },
                  placeholder: "请选择",
                  filterable: "",
                  clearable: "",
                },
                model: {
                  value: _vm.form.region,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "region", $$v)
                  },
                  expression: "form.region",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "配送模板", prop: "deliveryTemplateId" } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    placeholder: "请选择",
                    clearable: "",
                    filterable: "",
                  },
                  model: {
                    value: _vm.form.deliveryTemplateId,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "deliveryTemplateId", $$v)
                    },
                    expression: "form.deliveryTemplateId",
                  },
                },
                _vm._l(_vm.deliveryTemplates, function (tpl) {
                  return _c("el-option", {
                    key: tpl.id,
                    attrs: { label: tpl.name, value: tpl.id },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { attrs: { gutter: 16 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "起送费", prop: "startFee" } },
                    [
                      _c("el-input-number", {
                        staticStyle: { width: "100%" },
                        attrs: { precision: 2, step: 1, min: 0 },
                        model: {
                          value: _vm.form.startFee,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "startFee", $$v)
                          },
                          expression: "form.startFee",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "打包费", prop: "packageFee" } },
                    [
                      _c("el-input-number", {
                        staticStyle: { width: "100%" },
                        attrs: { precision: 2, step: 1, min: 0 },
                        model: {
                          value: _vm.form.packageFee,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "packageFee", $$v)
                          },
                          expression: "form.packageFee",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "最大出餐时间", prop: "maxCookMinutes" } },
            [
              _c(
                "el-input",
                {
                  attrs: { placeholder: "请输入" },
                  model: {
                    value: _vm.form.maxCookMinutes,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "maxCookMinutes", _vm._n($$v))
                    },
                    expression: "form.maxCookMinutes",
                  },
                },
                [_c("template", { slot: "append" }, [_vm._v("分钟")])],
                2
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { attrs: { gutter: 16 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "营业开始时间", prop: "bizStartTime" } },
                    [
                      _c("el-time-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          placeholder: "请输入",
                          "value-format": "HH:mm",
                          format: "HH:mm",
                        },
                        model: {
                          value: _vm.form.bizStartTime,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "bizStartTime", $$v)
                          },
                          expression: "form.bizStartTime",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "营业结束时间", prop: "bizEndTime" } },
                    [
                      _c("el-time-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          placeholder: "请输入",
                          "value-format": "HH:mm",
                          format: "HH:mm",
                        },
                        model: {
                          value: _vm.form.bizEndTime,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "bizEndTime", $$v)
                          },
                          expression: "form.bizEndTime",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c("el-button", { on: { click: _vm.handleClose } }, [
            _vm._v("取 消"),
          ]),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { type: "primary", loading: _vm.submitting },
              on: { click: _vm.handleSubmit },
            },
            [_vm._v("保 存")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }